export const alertsConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR',
  INFO: 'ALERT_INFO',
  CLEAR_ALL: 'ALERT_CLEAR_ALL',
};
